import React, {useContext, useEffect, useState} from "react";
import {azureTokenContext, userIdContext} from "../App";
import * as ApiCalls from "./Serving/ApiCalls.js";
import Loading from "./Serving/Loading";
import {NewsItem} from "../Types/NewsItem";
import {stripHtmlAndGetFirstWords, isContentLong} from "../utils/htmlUtils";

import moment from "moment";
import "moment/locale/nb";
import "../style/newsFeed.css";
import LinkToMainPage from "./Serving/LinkToMainPage";

moment.locale("nb");

export default function NewsFeed() {
    const WORD_LIMIT = 30;
    const azureToken = useContext(azureTokenContext);
    const userId = useContext(userIdContext);
    const [news, setNews] = useState<NewsItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [expandedNews, setExpandedNews] = useState<Set<string>>(new Set());

    useEffect(() => {
        ApiCalls.log("INFO", "Navigated to News feed", "AuthorsPortal", "", "", userId, azureToken);
        ApiCalls.getPublishedNews(azureToken)
            .then((res: NewsItem[]) => {
                setNews(res);
            })
            .catch(async (err: Error) => {
                console.error("Get published news failed.", err);
                ApiCalls.log("ERROR", "Failed getPublishedNews " + err.message, "AuthorsPortal", "", "", userId, azureToken);
            })
            .finally(() => {
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [azureToken]);

    const toggleExpand = (newsId: string) => {
        setExpandedNews((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(newsId)) {
                newSet.delete(newsId);
            } else {
                newSet.add(newsId);
            }
            return newSet;
        });
    };

    return (
        <div>
            <LinkToMainPage/>
            <div className="news-feed-page">

                <div className="news-feed-page-header">
                    <h1 className="news-feed-page-title">Nyheter</h1>
                </div>

                <div className="news-feed-list">
                    {loading && (
                        <div className="news-feed-loading">
                            <Loading/>
                        </div>
                    )}

                    {!loading && news.length === 0 && (
                        <div className="news-feed-empty">
                            Ingen nyheter tilgjengelig
                        </div>
                    )}

                    {!loading && news.map((item) => (
                        <div key={item.NewsId} className="news-feed-list-item">
                            <div className="news-feed-list-item-header">
                                <h2 className="news-feed-list-item-title">{item.Title}</h2>
                                <time
                                    className="news-feed-list-item-date"
                                    dateTime={moment(item.CreationTime).toISOString()}
                                >
                                    {moment(item.CreationTime).format("ll")}
                                </time>
                            </div>
                            <div className="news-feed-list-item-content">
                                {expandedNews.has(item.NewsId) ? (
                                    <div dangerouslySetInnerHTML={{__html: item.Content}}/>
                                ) : (
                                    <p>{stripHtmlAndGetFirstWords(item.Content, WORD_LIMIT)}</p>
                                )}
                            </div>
                            {isContentLong(item.Content, WORD_LIMIT) && (
                                <button
                                    className="news-feed-expand-btn"
                                    onClick={() => toggleExpand(item.NewsId)}
                                >
                                    {expandedNews.has(item.NewsId) ? 'Vis mindre' : 'Les mer'}
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}